exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-campaign .sb-page-section-title{margin-left:16px}.sb-campaign canvas{margin:0!important}.sb-campaign .sb-campaign-image-container img.sb-campaign-image{width:100%;height:auto}.sb-campaign .md-button{margin:6px 0}.sb-campaign .sb-form-actions{margin:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/campaign/campaign.scss
// module id = 691
// module chunks = 0